import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiDeviation, PapiUser } from '@wix/da-types-papi';
import SwipeSlider from '@wix/da-shared-react/pkg/SwipeSlider';
import DeviationStandardThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard';
import PostEditableItem from '../_partials/PostEditableItem';

import s from './Feed.scss';
import { withMobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';

export interface FeedWidgetProps {
  items: PapiDeviation[];
  pinnedDeviationId: number;
  profileOwnerUser: PapiUser;
  isOwner?: boolean;
  isMobile?: boolean;
}

export class FeedWidget extends React.Component<
  FeedWidgetProps & WithTranslation
> {
  render() {
    const { items, pinnedDeviationId, isMobile } = this.props;
    const sortedItems = this.sortItems(items, pinnedDeviationId);
    const itemsToShow = sortedItems.slice(0, 3);
    const RootComponent: any = isMobile ? SwipeSlider : 'div';

    return (
      <RootComponent className={s['root']}>
        {itemsToShow.map(item => {
          return (
            <PostEditableItem
              key={item.deviationId}
              className={s['item']}
              item={item}
            >
              <DeviationStandardThumb
                className={s['item-content']}
                deviation={item}
                height={462}
              />
            </PostEditableItem>
          );
        })}
      </RootComponent>
    );
  }

  sortItems = (items, pinnedItemId) => {
    if (!pinnedItemId) {
      return items;
    }

    const restItems: PapiDeviation[] = [];
    let pinnedItem;
    items.forEach(item => {
      if (item.deviationId === pinnedItemId) {
        pinnedItem = item;
      } else {
        restItems.push(item);
      }
    });

    if (!pinnedItem) {
      return items;
    }

    return [pinnedItem, ...restItems];
  };
}

export default withMobileContext(
  withTranslation()(FeedWidget)
) as React.ComponentType<FeedWidgetProps>;
